module.exports = __webpack_public_path__ + "img/9791188248094.f9e40de7.jpg";